<div class="w-full h-fit
            mt-16 lg:mt-32
            overflow-y-auto overflow-x-hidden">
  <div class="w-full bg-white
                flex flex-col">
    <!--  Top Section  -->
    <div class="w-full bg-white
                    border-b-2 border-divider
                    p-[0.938rem]">
      <div class="w-full max-w-container
                        mx-auto flex
                        flex-row flex-nowrap
                        justify-between items-center">
        <h1 class="text-lg text-darker font-semibold">
          Alle Schoonmaak Diensten
        </h1>

        <div class="hidden md:flex
                            gap-x-1.5 justify-end">
                    <span [routerLink]="['/']"
                          class="cursor-pointer hover:text-primary text-secondary-gray">Home /</span>

          <span class="text-darker">Diensten Overzicht</span>
        </div>
      </div>
    </div>
    <!--  Top Section  -->

    <div class="w-full bg-white
                    flex flex-col
                    mt-[1rem] md:mt-[5rem]">
      <!--  Body  -->
      <div class="w-full max-w-header
                        mx-auto flex
                        flex-col gap-8">
        <div class="w-full flex
                            flex-col gap-2
                            p-[0.938rem]
                            md:mx-auto
                            md:text-center">
          <div class="w-full text-2xl
                                leading-[2.25rem]
                                md:text-[2.375rem]
                                md:leading-[3.563rem]
                                text-darker font-semibold">
            Kies een schoonmaakpakket, bekijk direct je offerte en boek ons online!
          </div>


          <div class="h-1 w-32
                                bg-divider md:mx-auto
                                my-[0.9rem] md:my-[1rem]"></div>

          <div class="w-full max-w-[44rem] md:mb-4
                                mx-auto text-secondary-gray">
            Kies hier een pakket. Achter elke keuze vind je onze werkzaamheden. Of kies de schoonmaak per
            uur, dan mag je het zelf zeggen. Je ziet eerst de prijs voordat je gaat bestellen.
          </div>
        </div>
      </div>

      <div class="w-full max-w-container
                        mx-auto flex
                        justify-around flex-wrap">
        <div
          #packageItem
          *ngFor="let item of packages; let i = index"
             class="w-full px-6 py-8
                            min-w-[21.813rem] max-w-[29.125rem]" >
          <sw-card [item]="item"
                   [btn1]="true"
                   [btn2]="true"
                   [showIconRight]="true"
                   (btn1Click)="onBtn1($event)"
                   (btn2Click)="onBtn2($event)"
          ></sw-card>
        </div>
      </div>

      <div class="w-full flex
                        mb-14 md:my-[5rem]
                        justify-center items-center">
        <button type="button"
                [routerLink]="['/klantenservice']"
                class="min-h-[3.813rem] px-14
                               text-lg md:px-20 py-2
                               ripple disabled:cursor-wait
                               font-semibold text-white
                               rounded-full bg-primary">
          Ik heb nog een vraag
        </button>
      </div>
    </div>

    <div class="w-full max-w-header
                    mx-auto flex
                    mb-[2rem] md:mb-[3rem]
                    flex-col gap-8">
      <div class="w-full flex
                        flex-col gap-2
                        p-[0.938rem]
                        md:mx-auto
                        md:text-center">
        <div class="w-full text-2xl
                            leading-[2.25rem]
                            md:text-[2.375rem]
                            md:leading-[3.563rem]
                            text-darker font-semibold">
          Inmiddels hebben we al meer dan 100.000 huizen schoongemaakt!
        </div>


        <div class="h-1 w-32
                            bg-divider md:mx-auto
                            my-[0.9rem] md:my-[1rem]"></div>
      </div>
    </div>

    <!--  Postcode   -->
    <div class="w-full md:bg-primary
                    text-white md:py-12
                    mb-[3.125rem]">
      <sw-zip-code [customBackground]="true"></sw-zip-code>
    </div>
    <!--  Postcode  -->

    <div class="w-full max-w-container
                    pb-12 -mt-[3.125rem] mx-auto
                    flex flex-col">
      <sw-ratings></sw-ratings>

      <div class="w-full my-6
                        px-[0.938rem] pt-4
                        md:pt-14">
        <sw-cleaning-info></sw-cleaning-info>
      </div>
    </div>
    <!--  Body  -->
  </div>
</div>
